import _ from 'lodash';
import * as ActionType from '../../core/ActionType';
import InitialState from '../../core/InitialState'

/**
 * 
 * @param {Estado} state 
 * @param {Ação} action 
 */
const motoristaReducer = (state = InitialState.motoristaReducer, action) => {
    switch (action.type) {
        case ActionType.GET_MOTORISTAS_RESPONSE || ActionType.ADD_MOTORISTA_RESPONSE || ActionType.EDIT_MOTORISTA_RESPONSE: {
            return {
                ...state,
                motoristaObject: _.assign(action.motoristaObject),
                error: _.assign(action.error)
            }
        }
        default: { return state; }
    }
}

export default motoristaReducer;